import { TranslationType } from '../types';

export enum MasterPoolLoanStatus {
  Entered = '00',
  Received = '01',
  Cancelled = '02',
  Rejected = '03',
  Refused = '04',
  Withdrawn = '05',
  Approved = '06',
  Issued = '07',
  Risked = '08',
  Finalized = '09',
  Saved = '10',
  Priced = '11',
  Offer = '12',
  Lock = '14',
  Expired = '15',
  New = '90',
  Rerisk = '91',
  Critical = '99'
}

export const loanStatusMapping = (t: TranslationType) => {
  const mapping = {
    '00': t('Entered'),
    '01': t('Received'),
    '02': t('Cancelled'),
    '03': t('Rejected'),
    '04': t('Refused'),
    '05': t('Withdrawn'),
    '06': t('Approved'),
    '07': t('Issued'),
    '08': t('Risked'),
    '09': t('Finalized'),
    '10': t('Saved'),
    '11': t('Priced'),
    '12': t('Offer'),
    '14': t('Lock'),
    '15': t('Expired'),
    '90': t('New'),
    '91': t('Rerisk'),
    '99': t('Critical')
  };
  return mapping;
};
